import { createContext } from 'react';

const CmsContext = createContext({})

export default CmsContext